// extracted by mini-css-extract-plugin
module.exports = {"section":"works_section__Ycv84","title":"works_title__3qSly","notification":"works_notification__ojZ5z"};